<template>
	<a-modal :title="'详情'" :visible="visible" centered :destroy-on-close="true" :mask-closable="false" @cancel="onClose" :width="'60%'">

        <a-descriptions :column="12" bordered :labelStyle="{width:'120px'}">
            <a-descriptions-item label="项目评审名称" :span="6">
                {{form.projectReviewName}}
            </a-descriptions-item>

            <a-descriptions-item label="评审时间" :span="6">
                {{form.reviewTime}}
            </a-descriptions-item>

            <a-descriptions-item label="评审地点" :span="6">
                {{form.reviewPlace}}
            </a-descriptions-item>
<!--            <a-descriptions-item label="计划评审时间" :span="6">
                {{ form.reviewPlanTime }}
            </a-descriptions-item>
            <a-descriptions-item label="提报单位" :span="6">
                {{form.createdBy}}
            </a-descriptions-item>
            <a-descriptions-item label="提报时间" :span="6">
                {{ form.createdTime }}
            </a-descriptions-item>-->
            <a-descriptions-item label="报名上限" :span="6">
                {{form.reviewExpertCount}}
            </a-descriptions-item>
            <a-descriptions-item label="评审要求" :span="12">
                {{form.reviewDemand}}
            </a-descriptions-item>
            <a-descriptions-item label="项目评审概述" :span="12">
                {{form.projectOverview}}
            </a-descriptions-item>

<!--            <a-descriptions-item label="会议纪要" :span="6">
                <FileUpload v-model:value="form.meetingMinutes" :show-btn="false" disabled ></FileUpload>
            </a-descriptions-item>

            <a-descriptions-item label="项目评审内容" :span="6">
                <FileUpload v-model:value="form.applicationAttachment" :show-btn="false" disabled ></FileUpload>
            </a-descriptions-item>-->

<!--            <a-descriptions-item :span="12" label="评审状态">
                <ReviewStatus :status="form.reviewStatus"/>
            </a-descriptions-item>-->




<!--            <a-descriptions-item label="原因" v-if="form.reviewStatus==='4'">
                {{form.auditDenyReason}}
            </a-descriptions-item>-->
        </a-descriptions>

        <template #footer>
            <a-button key="back" @click="onClose">关闭</a-button>
        </template>
	</a-modal>
</template>
<script>

import { formMixin } from "@/mixins";
/*import {FileUpload} from "@/components/form/upload/FileUpload"
import ReviewStatus from"./ReviewStatus"*/

export default {
	name: "AddOrEditModal",
    components: {
        /*ReviewStatus,
        FileUpload*/
    },
    mixins: [formMixin],
    data() {
        return {
            titlePrefix:"审核",
            form: {

            },
        }
    },
    created() {
    },
    methods: {

    },
}
</script>
<style scoped lang="less">

</style>
